import { getAccionSistemaTipoLabel } from "./accionSistemaLabels";

/**
 * All `tipo` values supported by AccionSistema (audit list); order is not guaranteed in UI — options are sorted by label.
 * @type {readonly string[]}
 */
export const ACCION_TIPO_CODES = Object.freeze([
  "bloqueo",
  "compra",
  "creacion",
  "desbloqueo",
  "descuento",
  "desinscripcion",
  "edicion",
  "edicion_solicitada",
  "eliminacion",
  "email_verificado",
  "inscripcion",
  "mensaje_enviado",
  "password_cambio",
  "password_reset",
  "password_setup",
  "permiso_cambio",
  "registro_usuario",
  "rol_cambio",
  "sesion_login",
  "sesion_logout",
  "solicitud_password_reset",
  "test_resultado_guardado",
]);

/**
 * Canonical user roles for the affected-profile filter (Usuario.rol enum).
 * @type {readonly string[]}
 */
export const ROL_PERFIL_CODES = Object.freeze(["director", "instructor", "alumno"]);

/**
 * @param {string} anyLabel
 * @returns {{ value: string, label: string }[]}
 */
export function getAccionTipoFilterOptions(anyLabel) {
  const sorted = [...ACCION_TIPO_CODES].sort((a, b) =>
    getAccionSistemaTipoLabel(a).localeCompare(getAccionSistemaTipoLabel(b), "es"),
  );
  return [
    { value: "", label: anyLabel },
    ...sorted.map((value) => ({
      value,
      label: getAccionSistemaTipoLabel(value),
    })),
  ];
}

/**
 * @param {string} anyLabel
 * @param {Record<string, string> | null | undefined} roleLabels
 * @returns {{ value: string, label: string }[]}
 */
export function getRolPerfilFilterOptions(anyLabel, roleLabels) {
  const map = roleLabels != null && typeof roleLabels === "object" ? roleLabels : {};
  const sorted = [...ROL_PERFIL_CODES].sort((a, b) => {
    const la = typeof map[a] === "string" && map[a] !== "" ? map[a] : a;
    const lb = typeof map[b] === "string" && map[b] !== "" ? map[b] : b;
    return la.localeCompare(lb, "es");
  });
  return [
    { value: "", label: anyLabel },
    ...sorted.map((value) => ({
      value,
      label: typeof map[value] === "string" && map[value] !== "" ? map[value] : value,
    })),
  ];
}
